// import axios from "axios";

import {login_mp} from "@/api/adminService";

// const {publicPath} = require("../../../web.config")
import {message} from 'ant-design-vue';
import nprogress from 'nprogress';
import {ls} from "@/utils/util"
import http from "./index";
// import { saveAs } from 'file-saver'
const resCode = {
    "A0230": "用户登陆已过期",
    "A0301": "访问未授权",
    "A0302": "正在授权中",
    "A0303": "用户授权申请被拒绝",
    "A0310": "因访问对象隐私设置被拦截",
    "A0311": "授权已过期",
    "A0312": "无权限使用 API",
    "A0320": "用户访问被拦截",
    "401": "用户登陆已过期"
};
const refreshToken = ls.get("refresh_token");
const service = (request, returnMsg = false, isValid = true) => {
    nprogress.done();
    nprogress.start();
    return new Promise((resolve, reject) => {

        request
            .then((res) => {
              console.log(res,"pppres")
                nprogress.done();
                if (!isValid) {
                    return resolve(res)
                }
                const {data, message: msg = '', code = 0} = res.data || {}

                // if (code == 401) {
                //     refreshFun()
                // }
                if (code === 200 || code === "00000") {

                    if (returnMsg) {
                        resolve({data, msg})
                    } else {
                        resolve(data)
                    }
                } else {
                    if (code == 500 && res.data.msg == "获取登录信息失败!") {
                        refreshFun()
                    }
                    // if (res.data.msg == "获取登录信息失败!") {
                    message.warning(res.data.msg || res.data.message);
                    //
                    // }
                    if (Object.keys(resCode).includes(code)) {
                        ls.clear();
                        // window.location.replace(`${publicPath}/login`);
                    }
                    reject(null)
                }
            })
            .catch((error) => {
                nprogress.done();
                if(error.response.status==401){
                    refreshFun()

                }else{

                    console.log('请求错误！')
                }
                reject(error)
            })
    })
};

export const request = ({
                            url,
                            params,
                            method = "post",
                            returnMsg = false,
                        }) => {
    return service(http({url: url, method: method, data: params}), returnMsg);
};
// // 验证是否为blob格式
// export async function blobValidate(data) {
//     try {
//         const text = await data.text()
//         JSON.parse(text)
//         return false
//     } catch (error) {
//         return true
//     }
// }
export const getUpload = ({url, params, returnMsg = false}) => {
    // console.log(returnMsg)
    // let http1 = http({url: url, method: 'post_upload', data: params});
    // console.log(http1)
    // return download(url, params)
    return service(http({url: url, method: 'post_upload', data: params}), returnMsg)
};
export const getAction = ({url, params, returnMsg = false, isValid = true}) => {
    return service(http({url: url, method: 'get', params: params}), returnMsg, isValid)
};
export const postAction = ({url, params, method = 'post', returnMsg = false, isValid = true}) => {
    return service(http({url: url, method: method, data: params}), returnMsg, isValid)
};
export const postJson = ({url, params, returnMsg = false}) => {
    return service(http({url: url, method: 'post_json', data: params}), returnMsg)
};
export const getJson = ({url, params, returnMsg = false}) => {
    return service(http({url: url, method: 'get_json', data: params}), returnMsg)
};
export const get = (url, returnMsg = false) => {
    return (params) => {
        return getAction({url, params, returnMsg})
    }
};
export const post = (url, returnMsg = false) => {
    return (params) => {
        return postAction({url, params, returnMsg})
    }
};


export const refreshFun = () => {
    postAction({
            url: login_mp.login,
            params: {
                grant_type: 'refresh_token',
                client_id: 'sc.smartpark',
                client_secret: 'secret',
                refresh_token: refreshToken,
                loginType: 'manage'
            },
            isValid: false
        }
    ).then((res) => {
        ls.set("token", res.data.access_token, 60 * 60 * 1000 * 12);
        ls.set("refresh_token", res.data.refresh_token);
        window.location.reload()
    })
    .catch((error) => {
        console.log(error)
        ls.clear();
        var logins = 'http://'+window.location.host+'/login?id=user'
        if(window.location.href==logins){
            return
        }else{
            window.location.href='/login?id=user';
            return false
        }
    });
}

